import * as types from './types';

export const resetStatus = () => ({
  type: types.RESET_STATUS
});

export const comfirm = () => ({
  type: types.COMFIRM
});


// WEBPACK FOOTER //
// ./src/state/status/actions.js